import React from "react";
import { useCfoLanguage } from "../../context/CfoLanguageContext";

function CfoLanguageToggle({ className = "", variant = "navbar" }) {
  const { lang, setLang } = useCfoLanguage();

  const isLight = variant === "light";
  const active = isLight ? "text-[#102a72]" : "text-white";
  const inactive = isLight
    ? "text-[#7c8ba1] hover:text-[#102a72]"
    : "text-white/55 hover:text-white/90";
  const separator = isLight ? "text-slate-300" : "text-white/35";

  return (
    <div
      className={`inline-flex items-center gap-1.5 text-sm font-bold ${className}`}
      role="group"
      aria-label={lang === "es" ? "Seleccionar idioma" : "Select language"}
    >
      <button
        type="button"
        onClick={() => setLang("es")}
        className={`transition ${lang === "es" ? active : inactive}`}
        aria-pressed={lang === "es"}
        aria-label="Español"
      >
        SP
      </button>
      <span className={`font-normal ${separator}`} aria-hidden="true">
        |
      </span>
      <button
        type="button"
        onClick={() => setLang("en")}
        className={`transition ${lang === "en" ? active : inactive}`}
        aria-pressed={lang === "en"}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
}

export default CfoLanguageToggle;
